import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import JuegosCasaFluidezLectoraImg from "../../components/UmmIApps/Cards/JuegosCasaFluidezLectoraImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import RuletaJuegos from "../../components/RuletaJuegos/RuletaJuegos";
import EdadHijo from "../../components/Form/Fields/EdadHijo";
import InteresHijo from "../../components/Form/Fields/InteresHijo";
import Superheroe from "../../components/Form/Fields/Superheroe";
import LugarJuegos from "../../components/Form/Fields/LugarJuegos";
import JuegosCasa from "../../components/Form/Fields/JuegosCasa";

const JuegosCasaFluidezLectora = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    handleBack,
    setTextoInicial,
    handleInitialPromptData,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
  } = useActividadesContext();

  const isButtonDisabled = !(
    promptData.edad &&
    promptData.interes &&
    promptData.superheroe &&
    promptData.lugar
  );
  const colorIconBack = " #BA4534";

  useEffect(() => {
    const init = {
      edad: 1,
      interes: "",
      superheroe: "",
      lugar: "",
    };
    const envoltorio = promptData.envoltorio || "ruleta_juegos";
    handleInitialPromptData(init, envoltorio);
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  useEffect(() => {
    if (promptData.ganador) {
      const envoltorio = promptData.envoltorio || "ruleta_juegos";
      const init = {
        edad: promptData.edad || 1,
        interes: promptData.interes || "",
        superheroe: promptData.superheroe || "",
        lugar: promptData.lugar || "",
      };
      handleInitialPromptData(init, envoltorio);
    }
  }, [promptData.ganador]);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={JuegosCasaFluidezLectoraImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        title="Juegos en casa para la fluidez lectora"
        description="Actividades y temas que fomentan el aprendizaje a través del juego."
        titleColor="#BA4534"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid container spacing={2} px={{ xs: 4, md: 6, lg: 8 }}>
            <Grid item xs={12} md={6}>
              <EdadHijo />
            </Grid>
            <Grid item xs={12} md={6}>
              <InteresHijo />
            </Grid>

            <Grid item xs={12} md={6}>
              <Superheroe />
            </Grid>
            <Grid item xs={12} md={6}>
              <LugarJuegos />
            </Grid>
          </Grid>

          <Grid container spacing={2} px={{ xs: 4, md: 6, lg: 8 }}>
            <JuegosCasa />
          </Grid>
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default JuegosCasaFluidezLectora;
